import { useEffect } from 'react'
import { showNotification } from '@mantine/notifications'
import { IconX } from '@tabler/icons-react'

export function useErrorNotifier(title: string, error?: { message: string } | null) {
  useEffect(() => {
    if (error) {
      showNotification({
        title,
        message: error.message,
        color: 'red',
        icon: <IconX/>,
      })
    }
  }, [title, error])
}
